import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import ReplaceSimForm from '../forms/ReplaceSimForm'
import PaymentInformation from './PaymentInformation'
import globals from '../globals'

const ReplaceSim = (props) => {
    return (
        <div>
            <div className='replacement-sim module' style={{ overflow: 'visible' }}>
                <Heading title='Replace SIM' />
                <ModuleWithLoader isLoaded className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>If you’ve lost your SIM, or if it’s damaged and needs to be replaced, you can order a replacement SIM here. Your new 3-in-1 SIM will fit any device and will be dispatched via Australia Post on the next business day after you place your order below.</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-md-6 offset-md-3'>
                            <ReplaceSimForm
                                serviceId={props.serviceId}
                                serviceNo={props.serviceDetails.serviceNo}
                                handleSuccess={() => globals.pushEvent('MobileOrderNewSim')}
                            />
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
            <PaymentInformation />
        </div>
    )
}

ReplaceSim.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.shape({
        serviceNo: PropTypes.string
    }).isRequired
}

export default ReplaceSim



// WEBPACK FOOTER //
// ./resources/js/modules/ReplaceSim.js